import { render, staticRenderFns } from "./Partner.vue?vue&type=template&id=15b2d706&"
import script from "./Partner.vue?vue&type=script&lang=js&"
export * from "./Partner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15b2d706')) {
      api.createRecord('15b2d706', component.options)
    } else {
      api.reload('15b2d706', component.options)
    }
    module.hot.accept("./Partner.vue?vue&type=template&id=15b2d706&", function () {
      api.rerender('15b2d706', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Administration/Billing/Partner.vue"
export default component.exports